import { Id, UserRole } from '@nextforce/api'

const keys = {
  all: ['observer_list'],
  list: (companyId?: Id, role?: UserRole) => ['observer_list', companyId, role],
  companyStores: (companyId?: Id) => ['company_stores', companyId],
  changes: (companyId?: Id) => [...keys.all, 'changes', companyId],
  detail: (companyId?: Id, userId?: Id) => [...keys.all, companyId, userId],
  addUser: (phoneNumber?: string) => [
    ...keys.all,
    'add_edit_user',
    phoneNumber,
  ],
}

export default keys
